import { useContentfulLiveUpdates } from '@contentful/live-preview/react';

import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { StickyLayout } from '@/components/StickyLayout';
import type { ContentfulFooterFragment } from '@/graphql/contentful/api';
import { DefaultLayoutDocument } from '@/graphql/contentful/api';
import type { WithChildren } from '@/lib/types';
import { theme } from '@/theme/getTheme';

import type { CMSLayoutDataProps } from '../Default';

export const SignInLayout = ({
  children,
  cmsData,
}: WithChildren & {
  cmsData?: CMSLayoutDataProps;
}) => {
  const liveCmsData = useContentfulLiveUpdates(cmsData, {
    query: DefaultLayoutDocument,
  });

  return (
    <StickyLayout
      backgroundColor='lightGrey'
      data-test-id='SignInLayoutStickyLayout'
    >
      {liveCmsData?.header ? (
        <Header
          draftMode={false}
          {...liveCmsData.header}
          cmsSearchOverlayData={liveCmsData.search}
          data-test-id='SignInLayoutHeader'
        />
      ) : (
        <Header
          data-test-id='SignInLayoutHeaderLogoOnly'
          draftMode={false}
          logoOnly
        />
      )}

      <StickyLayout.Main
        data-test-id='SignInLayoutStickyLayoutMain'
        headerBackground={
          liveCmsData?.header?.background ??
          theme.components.header.defaultBackground
        }
      >
        {children}
      </StickyLayout.Main>

      <Footer
        data-test-id='SignInLayoutFooter'
        footerData={(liveCmsData?.footer ?? {}) as ContentfulFooterFragment}
      />
    </StickyLayout>
  );
};

SignInLayout.displayName = 'SignInLayout';
